import styled from "styled-components";

export const Root = styled.div``;
export const Container = styled.table`
width: 100%;
`;
export const NftHeadingContainer = styled.tr`
  display: grid;
  grid-template-columns: 20% 20% 20% 20% 20%;
  align-items: flex-start;
  text-align: flex-start;
  border-radius: 10px;
  color: #fff;
  font-weight: 500;
  font-size: 24px;
  line-height: 140%;
  margin: 40px 0;
`;

export const NftDetailsWrapper = styled.tr`
  color: #fff;
  display: grid;
  margin-top: 20px;
  grid-template-columns: 20% 20% 20% 20% 20%;
  -webkit-box-align: center;
  align-items: flex-start;
  text-align: flex-start;
  padding: 0px 0px;
  box-shadow: 0px 0px 5px 5px #0000;
  border-radius: 5px;
`;

export const HeadingText = styled.th`
/* width: 100%; */
display: flex;
justify-content:flex-start;
align-items:center;
text-align:center;

`;
export const NftDetails = styled.td`
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 20px;
`;

export const ExportWrapper  = styled.div`
display: flex;
justify-content:end;
margin: 20px 0;

`;
